export default "__VITE_ASSET__CMrgl43Z__"